import { KalturaPurchaseStatus } from '@kaltura-ott/ott-client-types';
import {
  KuxSubscription,
  KuxPurchaseInfo,
  KuxPackage,
  FormatKalturaProductPricePpv,
  FormatProductPrice,
  PurchaseCache,
  getPurchaseCache,
} from '@kaltura-ott/tvpil';

import { Episode } from './Episode';
import { Movie } from './Movie';
import { Package } from './Package';
import { PlayableAsset } from './PlayableAsset';
import { Subscription } from './Subscription';

export const createSubscriptionEntity = (
  kuxAsset: KuxSubscription,
  asset: Package,
  purchaseInfo?: KuxPurchaseInfo,
): Subscription => {
  return new Subscription(kuxAsset, asset, purchaseInfo);
};

export const createPackageEntity = (kuxAsset: KuxPackage): Package => {
  return new Package(kuxAsset);
};

export const checkCachedPurchase = async (
  price: FormatKalturaProductPricePpv | FormatProductPrice,
  playableItem?: PlayableAsset,
  subscriptionIds?: string[],
): Promise<PurchaseCache[]> => {
  let cachedPrices: PurchaseCache[] = [];
  if (
    price &&
    [
      KalturaPurchaseStatus.free,
      KalturaPurchaseStatus.collectionPurchased,
      KalturaPurchaseStatus.subscriptionPurchased,
      KalturaPurchaseStatus.ppvPurchased,
      KalturaPurchaseStatus.pendingEntitlement,
    ].includes(price.purchaseStatus)
  ) {
    return (cachedPrices = []);
  }

  if ((playableItem instanceof Movie || playableItem instanceof Episode) && playableItem && playableItem.isTvod) {
    const cachePpv = await getPurchaseCache(playableItem.mediaFileId);
    if (cachePpv) {
      cachedPrices.push(cachePpv);
    }
  } else {
    if (subscriptionIds?.length) {
      await Promise.all(
        subscriptionIds.map(async (id) => {
          const cacheSub = await getPurchaseCache(undefined, id);
          if (cacheSub) {
            cachedPrices.push(cacheSub);
          }
        }),
      );
    }
  }

  return cachedPrices;
};

export const cachedPurchaseToPurchaseStatus = <T extends FormatProductPrice>(
  cachedPrices: PurchaseCache[],
  price: T,
) => {
  cachedPrices.forEach((cachedPrice) => {
    if (cachedPrice.purchaseState === 'OK') {
      if (price.purchaseStatus === KalturaPurchaseStatus.forPurchase) {
        price.purchaseStatus = KalturaPurchaseStatus.ppvPurchased;
        return;
      } else if (price.purchaseStatus === KalturaPurchaseStatus.forPurchaseSubscriptionOnly) {
        price.purchaseStatus = KalturaPurchaseStatus.subscriptionPurchased;
        return;
      }
    } else if (cachedPrice.purchaseState === 'Pending') {
      price.purchaseStatus = KalturaPurchaseStatus.pendingEntitlement;
      return;
    }
  });

  return price;
};
